var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-title"},[_c('h1',[_vm._v(" Organizamos y automatizamos tu empresa en menos de 2 meses ")]),_c('h3',[_vm._v(" Nos encargamos de implementar y poner en marcha una version personalizada de nuestro sistema. Desde el sistema ERP para gestion interna, paneles de control y un e-commerce, TODO AUTOMATIZADO. ")])])
}]

export { render, staticRenderFns }